import { toast } from 'react-toastify';
import config from 'config';

export const toastNetError = (msg: string) => {
    toast.error(msg, { toastId: config.networkErrToastId });
};

export const toastAuthError = (msg: string) => {
    toast.error(msg, {
        toastId: config.authErrorToastMessageId,
        autoClose: false,
    });
};
